import { FC, Fragment } from "react"

import { ChevronUpIcon } from "@heroicons/react/24/outline"
import { Dialog, Transition } from "@headlessui/react"
import { InputJson } from "./InputJson"
import { KeyboardIcon } from "../../icons/KeyboardIcon"
import { OutputDisplay } from "../output/OutputDisplay"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"

export type CalculationSlideoutProps = {
  open: boolean
  setOpen: (value: boolean) => void
  request: any
  response: any
  shareFunction?: () => void
  resetFunction?: () => void
}

export const CalculationSlideout: FC<CalculationSlideoutProps> = ({
  open,
  setOpen,
  request = null,
  response = null,
  shareFunction = () => {},
  resetFunction = () => {},
}) => {
  return (
    <>
      <div
        className="flex border-b border-slate-300 justify-between items-center fixed bottom-24 left-1/2 transform -translate-x-1/2 w-full max-w-sm h-20 bg-white rounded-t-2xl py-4 px-6 cursor-pointer shadow-slide"
        onClick={() => setOpen(true)}
      >
        <div className="w-10 h-10 rounded-full bg-violet-100 p-2">
          <KeyboardIcon />
        </div>
        <div className="font-semibold text-xs text-slate-800 w-full text-left px-2">CALCULATE</div>
        <ChevronUpIcon className="h-6 w-6" />
      </div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOpen}>
          <Transition.Child
            as={Fragment}
            enter="ease-in-out duration-150"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in-out duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-x-0 top-0 bottom-24 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-x-0 top-0 bottom-24 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed top-0 bottom-24 left-1/2 -translate-x-1/2 flex w-full max-w-sm ">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-150 sm:duration-700"
                  enterFrom="translate-y-[calc(100%-5rem)]"
                  enterTo="translate-y-10"
                  leave="transform transition ease-in-out duration-150 sm:duration-700"
                  leaveFrom="translate-y-10"
                  leaveTo="translate-y-[calc(100%-5rem)]"
                >
                  <Dialog.Panel className="pointer-events-auto relative w-screen max-w-sm">
                    <div className="flex h-[calc(100%-2.5rem)] flex-col bg-white w-full max-w-sm rounded-t-2xl">
                      <div
                        className="flex border-b border-slate-300 justify-between items-center w-full max-w-sm min-h-[80px] h-20 bg-white py-4 px-6 cursor-pointer rounded-t-2xl"
                        onClick={() => setOpen(!open)}
                      >
                        <div className="w-10 h-10 rounded-full bg-violet-100 p-2">
                          <KeyboardIcon />
                        </div>
                        <div className="font-semibold text-xs text-slate-800 w-full text-left px-2">CALCULATE</div>
                        <Transition.Child
                          as={Fragment}
                          enter="transition-transform transition ease-in-out duration-150 sm:duration-700"
                          enterFrom="rotate-0"
                          enterTo="rotate-180"
                          leave="transition-transform transition ease-in-out duration-150 sm:duration-700"
                          leaveFrom="rotate-180"
                          leaveTo="rotate-0"
                        >
                          <ChevronUpIcon className="h-6 w-6" />
                        </Transition.Child>
                      </div>

                      <Tabs className="h-[calc(100%-5rem)]">
                        <TabList className="flex mx-auto w-full text-sm text-gray-100 font-semibold h-10">
                          <Tab
                            selectedClassName="border-black text-black"
                            className="focus:outline-none list-none py-2 w-1/2 text-center border-b cursor-pointer"
                          >
                            FIELDS
                          </Tab>
                          <Tab
                            selectedClassName="border-black text-black"
                            className="focus:outline-none list-none py-2 w-1/2 text-center border-b cursor-pointer"
                          >
                            FOR DEVS
                          </Tab>
                        </TabList>

                        <div className="overflow-auto h-[calc(100%-2.5rem)]">
                          <TabPanel selectedClassName="!inline-block" className="hidden relative px-6 py-4 w-full">
                            <OutputDisplay response={response} resetFunction={() => setOpen(false)} />
                          </TabPanel>

                          <TabPanel
                            selectedClassName="!inline-block"
                            className="hidden relative px-6 py-4 h-full w-full"
                          >
                            <InputJson defaultValues={response} height="100%" />
                          </TabPanel>
                        </div>
                      </Tabs>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

